<template>
  <div class="bg_white boxs2 pl16 pr16 pt15 pb16">
    <h2 class="page_title ab c5a">口座情報の登録・変更</h2>
    <div class="mt20 c5a">
      <p>お手続き方法はWEBまたは書面のいずれかでお申込みいただけます。</p>
      <p class="mt10">「毎月口座引落し払い」で使用する口座をご変更する場合、ボーナスの振込口座も変更となります。また、「毎月口座引落し払い」のご変更はアプリ内の【定期購入設定】メニューから別途お手続きください。</p>
      <p class="mt10 red">※法人登録の方は書面でのお手続きをお願いいたします。</p>
    </div>
    <div class="btn_wrap mt32">
      <router-link class="btn_yellow mb20" :to="{ name: 'MemberBankAccountUseWeb' }">WEBで申し込む</router-link>
      <router-link class="btn_blue mt10" :to="{ name: 'MemberBankAccountUsePaper' }">書面で申し込む</router-link>
    </div>
  </div>
  <!-- ルート直叩きなどでのガード（アプリ互換） -->
  <!-- <div v-else class="bg_white pt16 pb16 pl16 pr16 ab">アクセスエラー<br>coNPusアプリから再度開き直してください。</div> -->
</template>

<script>
export default {
  name: 'MemberBankAccountUse',
}
</script>

<style scoped>
.btn_wrap {
  margin-top: 24px;
}
.mt10 {
  margin-top: 10px;
}
.red {
  color: #ff0000;
}
</style>




// WEBPACK FOOTER //
// src/views/member/bankAccount/Use.vue